// JavaScript
import "./scripts/main";

// import "./scripts/vendor/api-homepage";

// Styles
import "./scss/main.scss";

// Favicon
import "./favicon.ico";

// Web App Manifest
import "./site.webmanifest";
import "./icon.png";

// Tiles for Windows 8.1
import "./browserconfig.xml";
import "./tile.png";
import "./tile-wide.png";

// robots.txt
import "./robots.txt";

// humans.txt
import "./humans.txt";
